module.exports = __webpack_public_path__ + "static/media/ticket-uber-3.3b163e23.gif";